import { useState, createContext, useContext, useMemo, useEffect } from "react";

const PermissionsContext = createContext(null);

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(() => {
    const storedPermissions =
      localStorage.getItem("menuStructure") !== "undefined" &&
      JSON.parse(localStorage.getItem("userPermissions"));
    return storedPermissions || null;
  });

  useEffect(() => {
    const handleLocalDataChanged = () => {
      const storedPermissions = JSON.parse(
        localStorage.getItem("userPermissions")
      );
      setPermissions(storedPermissions);
    };

    document.addEventListener("localdatachanged", handleLocalDataChanged);

    return () => {
      document.removeEventListener("localdatachanged", handleLocalDataChanged);
    };
  }, []);

  const contextValue = useMemo(
    () => ({
      checkPermission: (key) =>
        permissions?.some((permission) => permission.claimKey === key),
      setPermissions,
    }),
    [permissions]
  );

  return (
    <PermissionsContext.Provider value={contextValue}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermission = () => {
  return useContext(PermissionsContext);
};
